import { __assign } from "tslib";
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export var SvgFileTypeFolder = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#E0E0E0", d: "M3.5 5.5h4.532a1 1 0 01.768.36l1.067 1.28a1 1 0 00.768.36H20.5v11h-17v-13z" }),
        React.createElement("path", { fill: "#727272", d: "M8.575 4c.272 0 .531.11.72.306l1.41 1.462a.998.998 0 00.72.306H21a1 1 0 011 1V19a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h5.575zm-.543 1.5H3.5v13h17v-11h-9.865a1 1 0 01-.768-.36L8.8 5.86a1 1 0 00-.768-.36z" }),
        React.createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=FileTypeFolder.js.map